import { i18n } from '../../i18n';
import { getSavedFilters } from '../../hooks';
import {
  momentTextFormat,
  showToRoles,
  filterWithUserId,
  formatContainerType,
  exportExcel,
} from '../../utils';
import { gateInsService } from '../../services';
import { getGateInStatus } from './utils';

export const handleExportExcelClick = async ({
  states,
  user,
  filteredStates,
  totalCount,
  sortField,
  sortDirection,
}: any) => {
  const oldFilters = getSavedFilters('belongs-to');
  let fileName = 'GATE-INS';
  if (oldFilters.yardName) fileName += `__${oldFilters.yardName}`;
  if (oldFilters.clientName) fileName += `__${oldFilters.clientName}`;
  let startDate = states.startDate ? momentTextFormat(states.startDate, user, true) : '';
  let endDate = states.endDate ? momentTextFormat(states.endDate, user, true) : '';

  const { data } = await gateInsService
    .getAllPreFormatProps({
      params: {
        ...filterWithUserId(filteredStates, user),
        onlyActive: states.status === 'ACTIVE' ? 'true' : 'false',
        take: totalCount,
        skip: 0,
        sortField,
        sortDirection,
      },
    })
    .then((res) => res.data);

  const excelData = data.map((container) => ({
    [i18n.t('common.client')]: showToRoles('adminRead', user)
      ? container.clientYard?.client.code
      : '',
    [i18n.t('label.containerNumber')]: container.number,
    [i18n.t('label.type')]: formatContainerType(container.type),
    [i18n.t('label.condition')]: container.condition,
    [i18n.t('label.status')]: getGateInStatus(container.gateIn.validTo, container.gateIn.status),
    [i18n.t('label.createdAt')]: container.gateIn.createdAt
      ? momentTextFormat(container.gateIn.createdAt, user)
      : '',
    [i18n.t('label.completedAt')]: container.gateIn.completedAt
      ? momentTextFormat(container.gateIn.completedAt, user)
      : '',
    [i18n.t('label.gateInDateFrom')]: container.gateIn.validFrom
      ? momentTextFormat(container.gateIn.validFrom, user)
      : (states.status === 'All' || states.status === 'COMPLETED') && container.gateIn.createdAt
      ? momentTextFormat(container.gateIn.createdAt, user)
      : '',
    [i18n.t('label.gateInDateTo')]: container.gateIn.validTo
      ? momentTextFormat(container.gateIn.validTo, user)
      : (states.status === 'All' || states.status === 'COMPLETED') && container.gateIn.completedAt
      ? momentTextFormat(container.gateIn.completedAt, user)
      : '',
    [i18n.t('label.licensePlateNumber')]: container.gateIn.driver?.licensePlateNumber,
  }));
  const filters = [
    {
      [i18n.t('label.country')]: states.country,
      [i18n.t('label.city')]: states.city,
      [i18n.t('common.yard')]: oldFilters.yardName,
      [i18n.t('common.client')]: oldFilters.clientName,
      [i18n.t('label.containerNumber')]: states.number,
      [i18n.t('label.type')]: formatContainerType(states.type),
      [i18n.t('label.status')]: states.status,
      [i18n.t('label.from')]: startDate,
      [i18n.t('label.to')]: endDate,
    },
  ];
  const sheets = [
    { data: excelData, sheetName: i18n.t('pages.gateIns.sheet.gateIns') },
    { data: filters, sheetName: i18n.t('pages.gateIns.sheet.filters') },
  ];

  if (startDate || endDate) {
    startDate = startDate || 'start';
    endDate = endDate || momentTextFormat(new Date(), user, true);
    fileName = `${fileName} ${startDate}__${endDate}`;
  }

  exportExcel({ sheets, fileName });
};
